import { links } from './links'
import { Section } from './section'

export const Config = { links, Section }
